module.exports = __webpack_public_path__ + "img/1F3C5.c6a5e8bf.svg";